import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerSection: {
        marginHorizontal: 0,
        justifyContent: 'space-between',
    },
    containerFormItem: {
        flexDirection: 'row',
        marginHorizontal: 6,
    },
    textSection: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginLeft: 12,
    },
    stamp: {
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: theme.colors.colorPrimary,
        borderRadius: 10,
        paddingHorizontal: 8,
        paddingVertical: 2,
    },
    containerFilters: {
        flexDirection: 'row',
        backgroundColor: 'white',
        paddingVertical: 6,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    containerNoMessage: {
        flex: 1,
        height: height - 250,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageNoMessage: {
        width: 120,
        height: 120,
    },
    titleNoMessage: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    descriptionNoMessage: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
})

export default styles
